import React, { useEffect, useState } from 'react';
import '../../styles/dashboard.css';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const apiDomain = process.env.REACT_APP_DOMAIN;
const apiURL = process.env.REACT_APP_APIURL;

export default function CreateGame(props) {
    const [createGame, setCreateGame] = useState({userId: props.adminData.id, userName: props.adminData.name, userEmail: props.adminData.email, companyName: '', teamName: '', gameName: '', gameDescription: '', velocity: '', shareVelocity: false, effortPoint: true, autoFlip: false, voteReveal: false, calculateScore: true});
    const [gameError, setGameError] = useState({companyName: '', teamName: '', gameName: '', gameDescription: ''});
    const navigate = useNavigate();

    useEffect(() =>{
        window.scrollTo(0, 0);
        axios.get(`${apiDomain}/api/session-data`).then((res)=>{
            if(res.data.id) {
              let tempCreateGame = createGame
              tempCreateGame["userId"] = res.data.id
              tempCreateGame["userName"] = res.data.name
              tempCreateGame["userEmail"] = res.data.email
              setCreateGame({...tempCreateGame});
              props.setAdminData({...res.data});
            }
            else {
                window.location.href = `${apiDomain}/user-login/`;
            }
        }).catch(err=>{
            window.location.href = `${apiDomain}/user-login/`;
        })
    }, [])

    const changeHandler = (e) => {
        if (e.target.type === 'checkbox') {
            setCreateGame({...createGame, [e.target.name] : e.target.checked})
        }
        else {
            setCreateGame({...createGame, [e.target.name] : e.target.value})
            setGameError({...gameError, [e.target.name]: e.target.value.trim() === "" ? "This Field is Required" : ''})
        }
    }

    const submitHandler = (e) => {
        e.preventDefault();
        const newErrorState = {
            companyName: createGame.companyName.trim() === "" ? "This Field is Required" : "",
            teamName: createGame.teamName.trim() === "" ? "This Field is Required" : "",
            gameName: createGame.gameName.trim() === "" ? "This Field is Required" : "",
            gameDescription: createGame.gameDescription.trim() === "" ? "This Field is Required" : ""
        };
        setGameError(newErrorState)
        const hasErrors = Object.values(newErrorState).some(error => error !== "");
        if(!hasErrors) {
            axios.post(`${apiURL}/initiate-game-event`, createGame).then((res)=> {
                let gameAdmin = res.data.admin;
                sessionStorage.setItem('gameAdmin', JSON.stringify(gameAdmin));
                navigate(`/invite-game/${res.data.channel_id}`)
                setCreateGame({gameName: '', gameDescription: '', velocity: '', shareVelocity: false, effortPoint: false, autoFlip: false, voteReveal: false, calculateScore: true})
            })
            .catch(err=>{
                alert(err.response.data.message)
            })
        }
    }

  return (
    <>
        <Container>
            <div className="bgs-grey col-lg-10 col-xl-8 mx-auto px-3 px-sm-4 py-4 p-md-5 br-20 my-4 my-sm-5">
                <h1 className='fs-35 cl-darkblue text-center mb-sm-4'>Create New Game</h1>
                <Form onSubmit={submitHandler} className='px-lg-4 px-xl-5 py-2 py-md-0'>
                    <Form.Group className="mb-3" controlId="companyName">
                        <Form.Label>Name of Company/Customer <span className='text-danger'>*</span></Form.Label>
                        <Form.Control onChange={changeHandler} size="lg"  type="text" name='companyName' value={createGame.companyName} placeholder='Enter Company/Customer Name'/>
                        {gameError.companyName ? <Form.Label className='text-danger mb-0 fs-6'>{gameError.companyName}</Form.Label> : ''}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="teamName">
                        <Form.Label>Team Name <span className='text-danger'>*</span></Form.Label>
                        <Form.Control onChange={changeHandler} size="lg"  type="text" name='teamName' value={createGame.teamName} placeholder='Enter Team Name'/>
                        {gameError.teamName ? <Form.Label className='text-danger mb-0 fs-6'>{gameError.teamName}</Form.Label> : ''}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="gameName">
                        <Form.Label>Game Name <span className='text-danger'>*</span></Form.Label>
                        <Form.Control onChange={changeHandler} size="lg"  type="text" name='gameName' value={createGame.gameName} placeholder='Enter Game Name'/>
                        {gameError.gameName ? <Form.Label className='text-danger mb-0 fs-6'>{gameError.gameName}</Form.Label> : ''}
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="gameDescription">
                        <Form.Label>Game Description <span className='text-danger'>*</span></Form.Label>
                        <Form.Control onChange={changeHandler} as="textarea" rows={3} name='gameDescription' value={createGame.gameDescription} placeholder='Enter Game Description'/>
                        {gameError.gameDescription ? <Form.Label className='text-danger mb-0 fs-6'>{gameError.gameDescription}</Form.Label> : ''}
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="velocity">
                        <Form.Label>Velocity <OverlayTrigger placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip>Agile teams can often predict how many effort points can be completed in one sprint. Enter your team's velocity here, and we'll let you know when your estimates hit their max.</Tooltip>}
                        ><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <mask id="mask0_6_744" style={{'mask-type':'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                            <rect width="18" height="18" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_6_744)">
                            <path d="M8.24921 12.7499H9.74921V8.24995H8.24921V12.7499ZM8.99921 6.74995C9.21171 6.74995 9.38983 6.67807 9.53358 6.53432C9.67733 6.39057 9.74921 6.21245 9.74921 5.99995C9.74921 5.78745 9.67733 5.60932 9.53358 5.46557C9.38983 5.32182 9.21171 5.24995 8.99921 5.24995C8.78671 5.24995 8.60858 5.32182 8.46483 5.46557C8.32108 5.60932 8.24921 5.78745 8.24921 5.99995C8.24921 6.21245 8.32108 6.39057 8.46483 6.53432C8.60858 6.67807 8.78671 6.74995 8.99921 6.74995ZM8.99921 16.4999C7.96171 16.4999 6.98671 16.3031 6.07421 15.9093C5.16171 15.5156 4.36796 14.9812 3.69296 14.3062C3.01796 13.6312 2.48358 12.8374 2.08983 11.9249C1.69608 11.0124 1.49921 10.0374 1.49921 8.99995C1.49921 7.96245 1.69608 6.98745 2.08983 6.07495C2.48358 5.16245 3.01796 4.3687 3.69296 3.6937C4.36796 3.0187 5.16171 2.48433 6.07421 2.09058C6.98671 1.69683 7.96171 1.49995 8.99921 1.49995C10.0367 1.49995 11.0117 1.69683 11.9242 2.09058C12.8367 2.48433 13.6305 3.0187 14.3055 3.6937C14.9805 4.3687 15.5148 5.16245 15.9086 6.07495C16.3023 6.98745 16.4992 7.96245 16.4992 8.99995C16.4992 10.0374 16.3023 11.0124 15.9086 11.9249C15.5148 12.8374 14.9805 13.6312 14.3055 14.3062C13.6305 14.9812 12.8367 15.5156 11.9242 15.9093C11.0117 16.3031 10.0367 16.4999 8.99921 16.4999ZM8.99921 14.9999C10.6742 14.9999 12.093 14.4187 13.2555 13.2562C14.418 12.0937 14.9992 10.6749 14.9992 8.99995C14.9992 7.32495 14.418 5.9062 13.2555 4.7437C12.093 3.5812 10.6742 2.99995 8.99921 2.99995C7.32421 2.99995 5.90546 3.5812 4.74296 4.7437C3.58046 5.9062 2.99921 7.32495 2.99921 8.99995C2.99921 10.6749 3.58046 12.0937 4.74296 13.2562C5.90546 14.4187 7.32421 14.9999 8.99921 14.9999Z" fill="#230F72"/>
                        </g>
                        </svg></OverlayTrigger>
                        </Form.Label>
                        <Form.Control onChange={changeHandler} size="lg"  type="number" name='velocity' min={1} value={createGame.velocity} placeholder='Eg: 100'/>
                    </Form.Group>
                    <div className="bgs-lightblue game-setting p-3 p-sm-4 br-10">
                        {createGame.velocity ? <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                            <Form.Label className='mb-0 pe-3'>Share the velocity with all players?</Form.Label>
                            <Form.Check onChange={changeHandler} type="switch" name="shareVelocity" checked={createGame.velocity ? createGame.shareVelocity : false}/>
                        </Form.Group> : ''}
                        <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                            <Form.Label className='mb-0 pe-3'>Are you also story pointing?</Form.Label>
                            <Form.Check onChange={changeHandler} type="switch" name="effortPoint" checked={createGame.effortPoint}/>
                        </Form.Group>
                        <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                            <Form.Label className='mb-0 pe-3'>Would you like to auto-flip the cards after everyone has voted?</Form.Label>
                            <Form.Check onChange={changeHandler} type="switch" name="autoFlip" checked={createGame.autoFlip}/>
                        </Form.Group>
                        <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                            <Form.Label className='mb-0 pe-3'>Would you like to allow players to change their vote after reveal?</Form.Label>
                            <Form.Check onChange={changeHandler} type="switch" name="voteReveal" checked={createGame.voteReveal}/>
                        </Form.Group>
                        <Form.Group className="d-flex justify-content-between align-items-center">
                            <Form.Label className='mb-0 pe-3'>Would you like Planning Poker® to calculate the score?</Form.Label>
                            <Form.Check onChange={changeHandler} type="switch" name="calculateScore" checked={createGame.calculateScore} />
                        </Form.Group>
                    </div>
                    <div className='text-center pt-4 mt-2'>
                        <button className='btn-one bgs-blue border-0 br-30 text-white' type="submit">Start Game</button>
                    </div>
                </Form>
            </div>
        </Container>
    </>
  )
}
